// For Later Login Page Setup

import React, { useState, useEffect } from 'react';
import { Card, Form, Input, Button } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import './login.css';
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import AuthService from '../../Components/auth/AuthService';
import Message from '../../Components/common/Message';
import { useDispatch } from 'react-redux';
import { styled } from '@mui/system'
import { showMessage } from '../../Components/Utils/message';
import { hideLoading, showLoading, useLoadingDispatch } from '../../context/loadingContext';
import { useSelector } from 'react-redux';
// import AppLogo from "../../assets/images/prefectosblack.png";

const Auth = new AuthService();

  const AntLabel = styled('div')`
  .ant-form-item-label > label {
    font-size: '18px';
    font-weight: 700;
  }
`;

function Copyright() {
    return (
      <Typography marginTop={5} variant="body2" color="textSecondary" align="center">
        {"Copyright © "}
        <Link color="inherit" href="https://prefectos.com/">
          Prefectos
        </Link>{" "}
        {new Date().getFullYear()}
        {"."}
      </Typography>
    );
  }

function Login() {
  // const [error, setError] = useState(null);
  const { type : userType, roles   } = useSelector((state) => state.AppState.userCreds);

  const [isLoading, setIsLoading] = useState(false);
  const [loadMessage, setLoadMessage] = React.useState("");
  const [type, setType] = React.useState("info");
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const layoutDispatch = useLoadingDispatch();
  const isAuthenticated = Auth.loggedIn();
  const isPinned = localStorage.getItem('access_pin');

  useEffect(() => {
  if (!isAuthenticated) return;

  // Admin or Manager (type 0 or 1) → dashboard
  if (userType <= 1) {
    navigate("/dashboard");
  }

  // Other users (type > 1)
  if (userType == 2 && roles?.some(r => r.role_id === 5) ) {
    if (!isPinned) {
      navigate("/pin");
    } else {
      navigate("/dashboard");
    }
  }
}, [isAuthenticated, userType, isPinned]);

  const getOBStatus = async () => {
    
        showLoading(layoutDispatch)
        try {
          
          const res = await Auth.post(`/ob/opening-balances`, {});
          if (res.ack) {
            if (res?.opening_balances.length > 0) {
              dispatch({
                type: 'SET_OB_STATUS',
                payload: res?.opening_balances[0]?.posted_by > 0 ? true : false,
              });
            }
          } else {
            showMessage("error", res.message);
          }
        } catch (error) {
          console.log(error);
          showMessage("error", "Something went wrong");
        } finally {
          hideLoading(layoutDispatch)
        }
      };

  

  const onFinish = async ({ email, password }) => {
    setLoadMessage("");
    setIsLoading(true)
    try {
    const result = await Auth.login(email, password);
    if (result.ack) {
      dispatch({ type: 'SET_USER_TYPE', payload: result?.type })
      dispatch({ type: 'SET_USER_ROLES', payload: result?.roles })
      const hasRole5 = result?.roles?.some(r => r.role_id === 5);

        if(result.type === 2 && hasRole5) {
        navigate("/pin");
      }
      else {
        navigate("/dashboard");
        getOBStatus();
      }
        setIsLoading(false)
    } else {
        setType("error");
        setLoadMessage(result.message);
        setIsLoading(false)
    }
    } catch (err) {
        setType("error");
        setLoadMessage(err.message);
        setIsLoading(false)
    }
  };

  return (
    <>
    <div className="main-div">
      <Card bordered className="login-card">
        <div className='img-div'>
        {/* <img height={"80px"} src={AppLogo} alt='app'/> */}
        </div>
        <Form layout="vertical" onFinish={onFinish} autoComplete="off">
        <AntLabel >
          <Form.Item
            label="Email"
            name="email"
            rules={[
              {
                required: true,
                type: 'email',
                message: 'Please input your email',
              },
            ]}
          >
            <Input size='large' prefix={<UserOutlined />} placeholder="Email Address" />
          </Form.Item>
          </AntLabel>
        <AntLabel >
          <Form.Item
            label="Password"
            name="password"
            rules={[
              {
                required: true,
                message: 'Please input your password',
              },
            ]}
          >
            <Input.Password size='large' prefix={<LockOutlined />} type="password" placeholder="Password" />
          </Form.Item>
          </AntLabel>
          <Form.Item className='button-container'>
            <Button loading={isLoading} style={{height: '40px', width: '120px', padding: '5px', fontSize:"16px" }} size='large' type="primary" htmlType="submit">
              Login
            </Button>
          </Form.Item>
        </Form>
        <Copyright />
      </Card>
    </div>
    <Message type={type} msg={loadMessage} />
    </>
  );
}
export default Login;
